module.exports = __webpack_public_path__ + "assets/img/6.3ddcc22a.png";